import type { OpportunityTask } from 'backend/types'
import { DateTime } from 'luxon'
import { formatDate } from '@/lib/format-utils'

export const excelColumns: { label: string; accessor: (row: OpportunityTask) => unknown }[] = [
  { label: 'タイトル', accessor: (row) => row.title },
  { label: '概要', accessor: (row) => row.description ?? '' },
  { label: '担当者', accessor: (row) => row.member_name ?? '' },
  { label: '期限', accessor: (row) => (row.expired_on ? formatDate(row.expired_on) : '') },
  { label: 'ステータス', accessor: (row) => row.opportunity_task_status_name ?? 'Open' },
  {
    label: '更新日時',
    accessor: (row) => {
      if (!row.updated_at) return ''
      const dt = DateTime.fromSeconds(Number(row.updated_at))
      return dt.isValid ? dt.toFormat('yyyy/MM/dd HH:mm:ss') : ''
    },
  },
]
